module.exports = __webpack_public_path__ + "img/8.560267da.png";